// John Pak - VWO Cart | Styling Checkout Button in Cart -- Black CTA Variant - 2/14/25

const isDesktop = window.matchMedia("(min-width: 768px)").matches;
if (isDesktop) {
  
  const checkoutBtnHTML =
    '<button type="submit" id="checkout" class="cart__checkout-button button " name="checkout" form="cart" style="color: rgb(255, 255, 255) !important; width: 350px; transform-origin: 175px 23.5px; perspective-origin: 175px 23.5px; inline-size: 350px;"> </button>';

  const titleElement = document.querySelector(".title-wrapper-with-link");

  // turns a string of html into a DOM node
  function htmlToNode(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    const nNodes = template.content.childNodes.length;
    return template.content.firstChild;
  }

  const checkoutBtn = htmlToNode(checkoutBtnHTML);
  checkoutBtn.textContent = "Check out";

  function addCustomCheckoutButton() {
    titleElement.insertBefore(checkoutBtn, titleElement.childNodes[2]);
  }

  // add the button
  addCustomCheckoutButton();
}
